// A production rebuild replaces every JS/CSS chunk with newly hashed
// filenames and removes the old ones (see deploy_to_live.sh). Any browser
// tab that was already open across a deploy still has the old chunk hashes
// baked into its loaded app bundle, so the first time it tries to lazy-load
// a route or component it fails with "Loading chunk N failed" / ChunkLoadError
// pointing at a file that no longer exists on the server.
//
// That isn't a real error - the fix is just to reload so the tab picks up
// the current build. We only do this once per tab/session: if the app still
// can't load right after reloading, something else is wrong, and we'd
// rather show the real error than loop forever.
const CHUNK_ERROR = /loading (chunk|css chunk) [\w.-]+ failed|chunkloaderror/i
const RELOAD_FLAG = 'gemgp:chunk-reload-attempted'

function isChunkLoadError(error) {
    if (!error) {
        return false
    }
    const message = error.message || String(error)
    return CHUNK_ERROR.test(message)
}

function reloadOnce() {
    let alreadyAttempted = false

    try {
        alreadyAttempted = !!sessionStorage.getItem(RELOAD_FLAG)
        if (!alreadyAttempted) {
            sessionStorage.setItem(RELOAD_FLAG, '1')
        }
    } catch (e) {
        // storage blocked (private mode, etc.) - still safe to reload once
    }

    if (alreadyAttempted) {
        return
    }

    window.location.reload()
}

export function installChunkReload(router) {
    // route-level: an async route component failed to load
    router.onError((error) => {
        if (isChunkLoadError(error)) {
            reloadOnce()
        }
    })

    // component-level: async components loaded outside routing (e.g. the
    // lazily-loaded PMH plugin widgets) reject as an unhandled promise
    // instead of going through the router
    window.addEventListener('unhandledrejection', (event) => {
        if (isChunkLoadError(event.reason)) {
            event.preventDefault()
            reloadOnce()
        }
    })

    // a successful boot means this build's chunks are all reachable, so
    // clear the flag - the *next* deploy should still get one reload too
    window.addEventListener('load', () => {
        try {
            sessionStorage.removeItem(RELOAD_FLAG)
        } catch (e) {
            // ignore
        }
    })
}
